export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const UPDATE_MODAL_CONTENT = 'UPDATE_MODAL_CONTENT';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGOUT = 'LOGOUT';

export const GET_USERS = 'GET_USERS';
export const USER_ERROR = 'USER_ERROR';
export const DELETE_USER = 'DELETE_USER';
export const ADD_USER = 'ADD_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const GET_USER = 'GET_USER';

export const GET_CATEGORIES = 'GET_CATEGORIES';
export const GET_CATEGORIES_PAGINATED = 'GET_CATEGORIES_PAGINATED';
export const CATEGORY_ERROR = 'CATEGORY_ERROR';
export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const ADD_CATEGORY = 'ADD_CATEGORY';
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const GET_CATEGORY = 'GET_CATEGORY';

export const GET_PROMOS = 'GET_PROMOS';
export const PROMO_ERROR = 'PROMO_ERROR';
export const DELETE_PROMO = 'DELETE_PROMO';
export const ADD_PROMO = 'ADD_PROMO';
export const UPDATE_PROMO = 'UPDATE_PROMO';
export const GET_PROMO = 'GET_PROMO';

export const GET_UNAPPROVED_PROMOS = 'GET_UNAPPROVED_PROMOS';
export const UNAPPROVED_PROMO_ERROR = 'UNAPPROVED_PROMO_ERROR';
export const DELETE_UNAPPROVED_PROMO = 'DELETE_UNAPPROVED_PROMO';
export const ADD_UNAPPROVED_PROMO = 'ADD_UNAPPROVED_PROMO';
export const UPDATE_UNAPPROVED_PROMO = 'UPDATE_UNAPPROVED_PROMO';
export const GET_UNAPPROVED_PROMO = 'GET_UNAPPROVED_PROMO';
export const GET_UNAPPROVED_PROMO_DRAFT = 'GET_UNAPPROVED_PROMO_DRAFT';
export const UNAPPROVED_LOADING = 'UNAPPROVED_LOADING';
export const REJECT_UNAPPROVED_PROMO = 'REJECT_UNAPPROVED_PROMO';

export const GET_PAGES = 'GET_PAGES';
export const ERROR_PAGE = 'ERROR_PAGE';
export const ADD_PAGE = 'ADD_PAGE';
export const EDIT_PAGE = 'EDIT_PAGE';
export const UPDATE_PAGE = 'UPDATE_PAGE';
export const GET_PAGE = 'GET_PAGE';
export const DELETE_PAGE = 'DELETE_PAGE';
export const LOADING_PAGE = 'LOADING_PAGE';

export const GET_MALLS = 'GET_MALLS';
export const MALL_ERROR = 'MALL_ERROR';
export const ADD_MALL = 'ADD_MALL';
export const UPDATE_MALL = 'UPDATE_MALL';
export const GET_MALL = 'GET_MALL';
export const DELETE_MALL = 'DELETE_MALL';
export const MALL_LOADING = 'MALL_LOADING';

export const GET_STORES = 'GET_STORES';
export const GET_STORE = 'GET_STORE';
export const DELETE_STORE = 'DELETE_STORE';
export const ADD_STORE = 'ADD_STORE';
export const UPDATE_STORE = 'UPDATE_STORE';
export const STORE_LOADING = 'STORE_LOADING';

export const GET_OUTLETS = 'GET_OUTLETS';
export const ADD_OUTLET = 'ADD_OUTLET';
export const DELETE_OUTLET = 'DELETE_OUTLET';
export const GET_OUTLET = 'GET_OUTLET';
export const UPDATE_OUTLET = 'UPDATE_OUTLET';

export const TOKEN_VALID = 'TOKEN_VALID';
export const TOKEN_ERROR = 'TOKEN_ERROR';
export const TOKEN_EXPIRED = 'TOKEN_EXPIRED';

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const HIDDEN_SIDEBAR = 'HIDDEN_SIDEBAR';
export const SHOW_SIDEBAR = 'SHOW_SIDEBAR';

export const GET_ADS = 'GET_ADS';
export const AD_ERROR = 'AD_ERROR';
export const DELETE_AD = 'DELETE_AD';
export const ADD_AD = 'ADD_AD';
export const UPDATE_AD = 'UPDATE_AD';
export const GET_AD = 'GET_AD';
export const AD_LOADING = 'AD_LOADING';
export const AD_SELECT_PROMO = 'AD_SELECT_PROMO';
export const AD_SUBMIT_DATA = 'AD_SUBMIT_DATA';

export const GET_OFFER_OPTIONS = 'GET_OFFER_OPTIONS';
export const OFFER_OPTION_ERROR = 'OFFER_OPTION_ERROR';
export const DELETE_OFFER_OPTION = 'DELETE_OFFER_OPTION';
export const ADD_OFFER_OPTION = 'ADD_OFFER_OPTION';
export const UPDATE_OFFER_OPTION = 'UPDATE_OFFER_OPTION';
export const GET_OFFER_OPTION = 'GET_OFFER_OPTION';
export const OFFER_OPTION_LOADING = 'OFFER_OPTION_LOADING';

export const ADD_POST = 'ADD_POST';
export const EDIT_POST = 'EDIT_POST';

export const GET_TAGS_PAGINATED = 'GET_TAGS_PAGINATED';
export const UPDATE_TAG = 'UPDATE_TAG';

export const GET_ADDRESSES_PAGINATED = 'GET_ADDRESSES_PAGINATED';
export const GET_ADDRESS = 'GET_ADDRESS';
export const UPDATE_ADDRESS = 'UPDATE_ADDRESS';
export const ADD_ADDRESS = 'ADD_ADDRESS';
export const DELETE_ADDRESS = 'DELETE_ADDRESS';

export const UPLOAD_SP_SET_MALL = 'UPLOAD_SP_SET_MALL';
export const UPLOAD_SP_SET_STORE = 'UPLOAD_SP_SET_STORE';

export const ADD_STAFF = 'ADD_STAFF';
export const GET_STAFF = 'GET_STAFF';
export const UPDATE_STAFF = 'UPDATE_STAFF';
export const DELETE_STAFF = 'DELETE_STAFF';

export const UPDATE_PERMISSION = 'UPDATE_PERMISSION';

export const UPDATE_CREDENTIAL = 'UPDATE_CREDENTIAL';

export const ADD_AREA = 'ADD_AREA';
export const GET_AREA = 'GET_AREA';
export const UPDATE_AREA = 'UPDATE_AREA';
export const DELETE_AREA = 'DELETE_AREA';

export const ADD_MASTER_NAME = 'ADD_MASTER_NAME';
export const GET_MASTER_NAME = 'GET_MASTER_NAME';
export const UPDATE_MASTER_NAME = 'UPDATE_MASTER_NAME';
export const DELETE_MASTER_NAME = 'DELETE_MASTER_NAME';
export const LOADING_MASTER_NAME = 'LOADING_MASTER_NAME';

export const ADD_MALL_MAP = 'ADD_MALL_MAP';
export const UPDATE_MALL_MAP = 'UPDATE_MALL_MAP';
